import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { SkipInterceptorHeader } from './util.service';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {

  constructor(private readonly injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(SkipInterceptorHeader)) {
      const headers = req.headers.delete(SkipInterceptorHeader);
      return next.handle(req.clone({ headers }));
    }
    const authService: AuthService = this.injector.get(AuthService);
    const newRequest = req.clone({
      headers: req.headers.set('Authorization', authService.getToken() ? `Bearer ${authService.getToken()}` : ' '),
    });
    return next.handle(newRequest);
  }
}